const BURST = "32.0,7.1 37.2,15.4 45.0,12.6 46.1,19.8 57.5,19.3 51.3,27.5 59.0,32.0 51.3,36.5 56.7,44.3 46.1,44.2 45.2,51.7 37.2,48.6 32.0,56.9 26.8,48.6 18.3,52.5 17.9,44.2 7.8,44.0 12.7,36.5 6.0,32.0 12.7,27.5 6.5,19.3 17.9,19.8 18.5,11.9 26.8,15.4";

export const LogoMark = ({ className = "h-9 w-9", bg = "#112E23" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <rect width="64" height="64" rx="14" fill={bg} />
    <polygon points={BURST} fill="#FFFFFF" stroke="#112E23" strokeWidth="1.5" strokeLinejoin="round" />
    <text x="32" y="37.5" textAnchor="middle" fontFamily="'Barlow Condensed', Arial Black, sans-serif" fontWeight="900" fontSize="17" fill="#0F1412" transform="rotate(-8 32 32)">
      POW
    </text>
  </svg>
);

export const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark />
    <span className={`leading-none ${light ? "text-[#F5F0E8]" : "text-[#112E23]"}`}>
      <span className="block font-display text-2xl font-black tracking-tight">POW</span>
      <span className="block text-[10px] font-mono uppercase tracking-[0.25em] opacity-80">Polocrosse Balls</span>
    </span>
  </span>
);
